/* Resources and files (AdminResources.dc.html), in the master brand: white, the ink, greys as tints of
   it, and gold only for the small accents (a flash's or a message's left bar). Every colour is a
   token (styles/tokens.css). Small grey text uses --shell-ink-60 at the least (4.5 to 1), where the
   board draws 0.55. Below 1180px the page is 1 column and the editor opens in a dialog; below 760px
   the rows stack their buttons under their words (Adam, 4 Oct, answer 5). */

.ar-visually-hidden { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; }

.ar-icon { fill: none; stroke: currentColor; stroke-width: 1.75; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.ar-icon--bold { stroke-width: 2.25; }

/* The note, with its padlock */
.ar-note .ar-icon { stroke: var(--shell-ink); }
.ar-note a { color: var(--shell-ink); }

/* ---- Buttons --------------------------------------------------------------------------------------- */
.ar-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 6px; border-radius: 7px; border: 1px solid transparent;
  font-family: inherit; font-weight: 700; white-space: nowrap; cursor: pointer; line-height: 1; text-decoration: none;
}
.ar-btn:disabled { cursor: default; }
.ar-btn--ink { background: var(--shell-ink); color: var(--shell-on-ink); border-color: var(--shell-ink); }
.ar-btn--line { background: var(--shell-bg); color: var(--shell-ink); border-color: var(--shell-ink-16); }
.ar-btn--line:hover:not(:disabled) { border-color: var(--shell-ink-45); }
.ar-btn--bare { background: transparent; color: var(--shell-ink-72); }
.ar-btn--bare:hover:not(:disabled) { color: var(--shell-ink); background: var(--shell-ink-06); }
.ar-btn--head { height: 30px; padding: 0 10px; font-size: 13px; }
.ar-btn--add { padding: 0 12px; margin-left: 4px; }
.ar-btn--row { height: 28px; padding: 0 10px; font-size: 12px; }
.ar-btn--row.ar-btn--line { margin-left: 4px; }
.ar-btn--row.ar-btn--bare { color: var(--shell-ink-66); }
.ar-btn--confirm { height: 30px; padding: 0 12px; font-size: 12px; }
.ar-btn--confirm.ar-btn--line { border-color: var(--shell-ink-20); }
.ar-btn--xs { height: 30px; padding: 0 10px; font-size: 12px; flex-shrink: 0; }
.ar-btn--xs.ar-btn--line { border-color: var(--shell-ink-20); }
.ar-btn--section { height: 38px; padding: 0 14px; border-radius: 8px; font-size: 13px; }
.ar-btn--save { height: 40px; padding: 0 18px; border-radius: 9px; font-size: 14px; }
.ar-btn--cancel { height: 40px; padding: 0 14px; border-radius: 9px; font-size: 14px; }
.ar-btn--see { align-self: flex-start; height: 34px; padding: 0 12px; border-radius: 8px; font-size: 13px; }
.ar-btn:disabled.ar-btn--ink, .ar-btn[aria-busy="true"] { opacity: 0.7; }

.ar-icon-btn {
  border: none; background: transparent; color: var(--shell-ink); display: inline-flex; align-items: center;
  justify-content: center; border-radius: 7px; padding: 0; cursor: pointer; flex-shrink: 0;
}
.ar-icon-btn--md { width: 30px; height: 30px; }
.ar-icon-btn--sm { width: 28px; height: 28px; }
.ar-icon-btn:hover:not([aria-disabled="true"]) { background: var(--shell-ink-06); }
.ar-icon-btn[aria-disabled="true"] { opacity: 0.25; cursor: default; }

/* ---- Product chips ------------------------------------------------------------------------------- */
.ar-products { display: flex; gap: 8px; flex-wrap: wrap; }
.ar-product {
  height: 38px; padding: 0 14px; border-radius: 19px; border: 1px solid var(--shell-ink-16); background: var(--shell-bg);
  color: var(--shell-ink); font-family: inherit; font-size: 14px; font-weight: 700; display: inline-flex; align-items: center; gap: 8px;
  cursor: pointer; white-space: nowrap;
}
.ar-product:hover { border-color: var(--shell-ink-45); }
.ar-product[aria-pressed="true"] { background: var(--shell-ink); color: var(--shell-on-ink); border-color: var(--shell-ink); }
.ar-product-count { font-weight: 600; opacity: 0.7; }
.ar-product-count:empty { display: none; }
.ar-dot { width: 9px; height: 9px; border-radius: 5px; flex-shrink: 0; display: inline-block; }
.ar-dot--ring { box-shadow: 0 0 0 1px var(--shell-ink-14); }
.ar-dot--sm { width: 7px; height: 7px; border-radius: 4px; }

/* ---- The 2 columns -------------------------------------------------------------------------------- */
.ar-grid { display: grid; grid-template-columns: minmax(0, 1.55fr) minmax(0, 1fr); gap: 24px; align-items: start; }
.ar-sections { display: flex; flex-direction: column; gap: 16px; min-width: 0; }
.ar-aside { display: flex; flex-direction: column; gap: 16px; min-width: 0; scroll-margin-top: 24px; }

/* ---- A section ----------------------------------------------------------------------------------- */
.ar-section { border-radius: 14px; border: 1px solid var(--shell-ink-10); overflow: hidden; background: var(--shell-bg); }
.ar-section-head {
  display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 12px 16px;
  background: var(--shell-ink-03); border-bottom: 1px solid var(--shell-ink-08); min-height: 55px;
}
.ar-section-name-line { display: flex; align-items: baseline; gap: 10px; min-width: 0; }
.ar-section-name { margin: 0; font-size: 16px; font-weight: 800; overflow-wrap: anywhere; }
.ar-section-count { font-size: 13px; color: var(--shell-ink-60); white-space: nowrap; }
.ar-section-actions { display: flex; align-items: center; gap: 4px; flex-shrink: 0; }
.ar-rename { display: flex; gap: 8px; align-items: center; flex-grow: 1; }
.ar-section-msg {
  padding: 10px 16px; background: var(--shell-ink-04); box-shadow: inset 3px 0 0 var(--shell-gold);
  font-size: 13px; font-weight: 600; line-height: 1.5;
}
.ar-section-empty { margin: 0; padding: 14px 16px; font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }

/* An item */
.ar-items { list-style: none; margin: 0; padding: 0; }
.ar-item { border-bottom: 1px solid var(--shell-ink-06); background: var(--shell-bg); }
.ar-item--editing { background: var(--shell-ink-05); }
.ar-item-row { display: flex; align-items: center; gap: 12px; padding: 10px 12px 10px 14px; }
.ar-item:not(.ar-item--editing) .ar-item-row:hover { background: var(--shell-ink-02); }
.ar-kind {
  width: 34px; height: 34px; border-radius: 8px; background: var(--shell-ink-05); color: var(--shell-ink);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.ar-item-text { flex-grow: 1; display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.ar-item-title-line { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.ar-item-title { font-size: 14px; font-weight: 700; line-height: 1.4; overflow-wrap: anywhere; }
.ar-badge {
  height: 20px; padding: 0 7px; border-radius: 10px; border: 1px solid var(--shell-ink-20);
  font-size: 11px; font-weight: 800; display: inline-flex; align-items: center; white-space: nowrap;
}
.ar-badge--new { background: var(--shell-ink); color: var(--shell-on-ink); border-color: var(--shell-ink); }
.ar-item-meta { font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); overflow-wrap: anywhere; }
.ar-item-opens { font-size: 12px; font-weight: 700; color: var(--shell-ink); }
.ar-item-actions { display: flex; align-items: center; gap: 2px; flex-shrink: 0; }

/* Remove's confirm, and a section's */
.ar-confirm {
  margin: 0 14px 12px; padding: 12px 14px; border-radius: 9px; background: var(--shell-ink-04);
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
}
.ar-confirm--section { margin: 12px 14px; }
.ar-confirm-text { font-size: 13px; line-height: 1.5; }
.ar-confirm-actions { display: flex; gap: 6px; flex-shrink: 0; }

/* Removed in the last 30 days */
.ar-removed { padding: 10px 16px 12px; border-top: 1px solid var(--shell-ink-06); display: flex; flex-direction: column; gap: 6px; }
.ar-removed-head { margin: 0; font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.ar-removed-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 6px; }
.ar-removed-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.ar-removed-text { font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); min-width: 0; }
.ar-removed-title { display: block; font-size: 13px; font-weight: 700; color: var(--shell-ink); overflow-wrap: anywhere; }

/* A new section */
.ar-new-section {
  display: flex; gap: 8px; align-items: center; padding: 12px; border-radius: 12px; border: 1px dashed var(--shell-ink-30);
}

/* ---- Inputs -------------------------------------------------------------------------------------- */
.ar-input {
  height: 40px; padding: 0 12px; border-radius: 8px; border: 1px solid var(--shell-ink-16); background: var(--shell-bg);
  font-family: inherit; font-size: 14px; font-weight: 500; color: var(--shell-ink); width: 100%; min-width: 0;
  letter-spacing: 0; text-transform: none;
}
.ar-input::placeholder { color: var(--shell-ink-60); }
.ar-input--title { font-weight: 600; }
.ar-input--small { font-size: 13px; }
.ar-input--rename { height: 34px; padding: 0 10px; font-size: 14px; font-weight: 700; flex-grow: 1; width: auto; }
.ar-input--section { height: 38px; flex-grow: 1; width: auto; }
.ar-input--date { height: 34px; padding: 0 10px; font-size: 13px; margin-top: 4px; max-width: 220px; }
.ar-textarea { height: 96px; padding: 10px 12px; font-size: 13px; line-height: 1.5; resize: vertical; }

/* ---- The aside's cards ----------------------------------------------------------------------------- */
.ar-card { border-radius: 14px; border: 1px solid var(--shell-ink-10); background: var(--shell-bg); padding: 22px; display: flex; flex-direction: column; gap: 10px; }
.ar-closed-title, .ar-editor-title { margin: 0; font-size: 17px; font-weight: 800; }
.ar-card-text { margin: 0; font-size: 14px; line-height: 1.6; color: var(--shell-ink-66); }
.ar-card-text--sm { font-size: 13px; }
.ar-how { padding: 20px 22px; }
.ar-how-title { margin: 0; font-size: 15px; font-weight: 800; }

/* The flash, with the gold bar (the board's green bar is the Accelerator's colour, a brand leak) */
.ar-flash {
  padding: 12px 14px; border-radius: 10px; background: var(--shell-ink-03); border: 1px solid var(--shell-ink-14);
  box-shadow: inset 4px 0 0 var(--shell-gold); font-size: 13px; font-weight: 700; line-height: 1.5;
}
.ar-flash-wrap { position: sticky; bottom: 16px; z-index: 5; order: 99; }
.ar-flash-wrap .ar-flash { background: var(--shell-bg); box-shadow: inset 4px 0 0 var(--shell-gold), 0 8px 24px var(--admin-dialog-shadow); }
.ar-problem { margin: 0; font-size: 13px; font-weight: 700; line-height: 1.5; color: var(--shell-ink); }

/* ---- The editor ------------------------------------------------------------------------------------ */
.ar-editor { gap: 16px; }
.ar-card.ar-editor { border: 1.5px solid var(--shell-ink); }
.ar-editor--dialog { display: flex; flex-direction: column; }
.ar-editor-head { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.ar-editor-title { overflow-wrap: anywhere; }
.ar-editor-foot { display: flex; gap: 8px; padding-top: 4px; flex-wrap: wrap; }
.ar-ed-group { display: flex; flex-direction: column; gap: 6px; }
.ar-ed-label { font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.ar-ed-field { display: flex; flex-direction: column; gap: 6px; }
.ar-ed-note { font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); }
.ar-ed-note--tight { margin-top: -8px; }
.ar-picks { display: flex; flex-wrap: wrap; gap: 6px; }
.ar-weeks { margin-top: 4px; }
.ar-pick {
  height: 32px; padding: 0 11px; border-radius: 8px; border: 1.5px solid var(--shell-ink-14); background: var(--shell-bg);
  color: var(--shell-ink); font-family: inherit; font-size: 12px; font-weight: 700; cursor: pointer; display: inline-flex;
  align-items: center; gap: 6px; white-space: nowrap;
}
.ar-pick:hover:not(:disabled) { border-color: var(--shell-ink-45); }
.ar-pick[aria-pressed="true"] { border-color: var(--shell-ink); background: var(--shell-ink-05); }
.ar-pick:disabled { opacity: 0.45; cursor: default; }
.ar-pick--sm { height: 30px; padding: 0 10px; }
.ar-pick--week { width: 44px; height: 30px; padding: 0; justify-content: center; font-weight: 800; }
.ar-pick--also { height: 30px; padding: 0 10px; border-radius: 15px; }
.ar-filebox {
  display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 10px 12px; border-radius: 8px;
  border: 1px dashed var(--shell-ink-30);
}
.ar-filebox-line { font-size: 13px; font-weight: 600; min-width: 0; overflow-wrap: anywhere; }
.ar-file-input { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; }
.ar-checks { display: flex; flex-direction: column; gap: 8px; }
.ar-check { display: flex; gap: 10px; align-items: flex-start; font-size: 13px; line-height: 1.45; cursor: pointer; }
.ar-check input { width: 17px; height: 17px; margin: 1px 0 0; accent-color: var(--shell-ink); flex-shrink: 0; }
.ar-check b { font-weight: 700; }

/* ---- Narrower: 1 column, and the editor in a dialog --------------------------------------------- */
@media (max-width: 1180px) {
  .ar-grid { grid-template-columns: minmax(0, 1fr); }
}

/* ---- A phone ----------------------------------------------------------------------------------------- */
@media (max-width: 760px) {
  .ar-product { height: 36px; padding: 0 12px; font-size: 13px; }
  .ar-section-head { flex-wrap: wrap; padding: 12px 14px; }
  .ar-section-name-line { width: 100%; }
  .ar-section-actions { width: 100%; flex-wrap: wrap; }
  .ar-btn--add { margin-left: auto; }
  .ar-rename { flex-wrap: wrap; }
  .ar-input--rename { flex-basis: 100%; }
  .ar-item-row { flex-wrap: wrap; align-items: flex-start; padding: 12px 14px; }
  .ar-item-text { flex-basis: calc(100% - 46px); }
  .ar-item-actions { width: 100%; padding-left: 46px; flex-wrap: wrap; gap: 4px; }
  .ar-item-actions .ar-btn--row.ar-btn--line { margin-left: auto; }
  .ar-confirm, .ar-removed-row { flex-direction: column; align-items: stretch; }
  .ar-confirm-actions { flex-wrap: wrap; }
  .ar-new-section { flex-direction: column; align-items: stretch; }
  .ar-input--section, .ar-btn--section { width: 100%; }
  .ar-card { padding: 18px 16px; }
  .ar-input, .ar-textarea { font-size: 16px; }
  .ar-removed-row .ar-btn { align-self: flex-start; }
  /* at least 24px to tap (item 178) */
  .ar-check { min-height: 24px; }
}
